/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MyMembership } from './MyMembership';
import {
    MyMembershipFromJSON,
    MyMembershipFromJSONTyped,
    MyMembershipToJSON,
} from './MyMembership';

/**
 * 
 * @export
 * @interface GetAccountMembership200Response
 */
export interface GetAccountMembership200Response {
    /**
     * 
     * @type {MyMembership}
     * @memberof GetAccountMembership200Response
     */
    data: MyMembership;
}

/**
 * Check if a given object implements the GetAccountMembership200Response interface.
 */
export function instanceOfGetAccountMembership200Response(value: object): value is GetAccountMembership200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetAccountMembership200ResponseFromJSON(json: any): GetAccountMembership200Response {
    return GetAccountMembership200ResponseFromJSONTyped(json, false);
}

export function GetAccountMembership200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountMembership200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': MyMembershipFromJSON(json['data']),
    };
}

export function GetAccountMembership200ResponseToJSON(value?: GetAccountMembership200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': MyMembershipToJSON(value['data']),
    };
}

